import type { WriteOp } from "../components/WriteOpsHint";

export const SYSTEM_WRITE_OPS: WriteOp[] = [
  {
    channel: "HTTP",
    label: "Outbox replay (alle Events)",
    snippet:
      'curl -X POST -H "Authorization: Bearer $KW_TOKEN" -H "Content-Type: application/json" \\\n  http://kontextwerk.localhost:8080/core/v1/admin/replay-outbox \\\n  -d \'{"reset_all": true}\'',
  },
  {
    channel: "HTTP",
    label: "Outbox replay (selektive Artefakte)",
    snippet:
      'curl -X POST -H "Authorization: Bearer $KW_TOKEN" -H "Content-Type: application/json" \\\n  http://kontextwerk.localhost:8080/core/v1/admin/replay-outbox \\\n  -d \'{"artifact_ids": ["<uuid1>", "<uuid2>"]}\'',
  },
  {
    channel: "HTTP",
    label: "Staging-FS Cleanup-Pass",
    snippet:
      'curl -X POST -H "Authorization: Bearer $KW_TOKEN" \\\n  http://kontextwerk.localhost:8080/core/v1/admin/staging-cleanup',
  },
  {
    channel: "CLI",
    label: "Outbox replay (nur Dead-Letter, D-INGEST-49)",
    snippet: "kontextwerk-cli admin replay-outbox --dead-only",
  },
  {
    channel: "CLI",
    label: "Realm-Update-Plan Preview (D-PACK-35)",
    snippet: "kontextwerk-pack plan --realm <realm_id>",
  },
  {
    channel: "HTTP",
    label: "Realm-Update-Plan anwenden (triggert Replay, D-PACK-35)",
    snippet:
      'curl -X PATCH -H "Authorization: Bearer $KW_TOKEN" -H "Content-Type: application/json" \\\n  http://kontextwerk.localhost:8080/core/v1/admin/realms/<realm_id>/pack-bindings \\\n  -d \'{"pack_bindings": ["kw:base@s2", "<ns>:<name>@s1"]}\'',
  },
  {
    channel: "CLI",
    label: "Pack paketieren (.tgz, D-PACK-15)",
    snippet: "kontextwerk-pack package ./<ns>/<name> --out-dir ./dist",
  },
  {
    channel: "HTTP",
    label: "Pack hochladen + stagen (Upsert, D-PACK-16)",
    snippet:
      'curl -X POST -H "Authorization: Bearer $KW_TOKEN" \\\n  -F "file=@./dist/kw-<ns>-<name>-<ver>.tgz" \\\n  http://kontextwerk.localhost:8080/core/v1/admin/packs',
  },
  {
    channel: "HTTP",
    label: "Core neu starten (gestagte Packs aktivieren, D-PACK-18)",
    snippet:
      'curl -X POST -H "Authorization: Bearer $KW_TOKEN" \\\n  http://kontextwerk.localhost:8080/core/v1/admin/restart',
  },
];
